module.exports = __webpack_public_path__ + "static/media/12_nature.b413eb25.jpg";